import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Brands from "../../../components/common/Brands";
import Testimonials from "../../../components/common/Testimonials";
import Footer1 from "../../../components/footer/Footer1";
import Header1 from "../../../components/headers/Header1";
import Agents from "../../../components/common/Agents2";
import Benefit from "../../../components/homes/home-2/Benefit";
import Blogs from "../../../components/homes/home-2/Blogs";
import Blogs2 from "../../../components/blogs/Blogs2.jsx";
import Categories from "../../../components/homes/home-2/Categories";
import Hero from "../../../components/homes/home-2/Hero";
import Locations from "../../../components/homes/home-2/Locations";
import Properties from "../../../components/homes/home-2/Properties";
import Properties2 from "../../../components/homes/home-2/Properties2";
import { GetAllPropertyforWeb, GetAllPropertyTypesforWeb, GetAllPageBannerforWeb } from "../../../APIs/APIHelperforWeb.js";
import Faqs from "../../../components/otherPages/Faqs.jsx";

import { useSnackbar } from "notistack";
import MetaComponent from "../../../components/common/MetaComponent";
import Categories2 from "../../../components/homes/home-2/Categories2.jsx";




export default function HomePage2() {
  const pathname = '/home';

  const [MetaTitle, setMetaTitle] = React.useState("");
  const [MetaDescription, setMetaDescription] = React.useState("");
  const [MetaKeywords, setMetaKeywords] = React.useState("");
  const [MetaImage, setMetaImage] = React.useState("");

  const metadata = {
    title: MetaTitle,
    description: MetaDescription,
    keywords: MetaKeywords,
    url: window.location.href,
    siteName: "AskMeRealty",
    canonical: window.location.href,
    
  };

  const { enqueueSnackbar } = useSnackbar();

  const [objAllProperties, setAllProperties] = React.useState([]);
  const [objFeaturedProperties, setFeaturedProperties] = React.useState([]);
  const [propertyTypes, setPropertyTypes] = React.useState([]);
  const [LocationName, setLocationName] = React.useState("");


  const normalizePath = (value = "") => {
    const rawValue = String(value || "").trim();
    if (!rawValue) return "/";

    let pathValue = rawValue;
    try {
      if (/^https?:\/\//i.test(rawValue)) {
        pathValue = new URL(rawValue).pathname;
      }
    } catch (error) {
      pathValue = rawValue;
    }

    const withoutQueryOrHash = decodeURIComponent(pathValue)
      .split(/[?#]/)[0]
      .trim()
      .toLowerCase();
    if (!withoutQueryOrHash) return "/";

    const withLeadingSlash = withoutQueryOrHash.startsWith("/")
      ? withoutQueryOrHash
      : `/${withoutQueryOrHash}`;

    const compactSlashes = withLeadingSlash.replace(/\/+/g, "/");
    return compactSlashes.length > 1
      ? compactSlashes.replace(/\/+$/, "")
      : compactSlashes;
  };

  const getPageNameFromPath = (path) => {
    const cleanPath = normalizePath(path);
    const segment = cleanPath.split("/").filter(Boolean).pop() || "page";
    return segment
      .replace(/[-_]+/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getBestBannerMatch = (rows, activePath) => {
    if (!Array.isArray(rows) || rows.length === 0) return null;

    const scoredMatches = rows
      .map((item) => {
        const bannerPath = normalizePath(item?.PageURL);
        if (!bannerPath || bannerPath === "/") {
          return null;
        }

        let score = 0;
        if (bannerPath === activePath) {
          score = 4;
        } else if (activePath.startsWith(`${bannerPath}/`)) {
          score = 3;
        } else if (bannerPath.startsWith(`${activePath}/`)) {
          score = 2;
        } else {
          const activeSlug = activePath.split("/").filter(Boolean).pop();
          const bannerSlug = bannerPath.split("/").filter(Boolean).pop();
          if (activeSlug && bannerSlug && activeSlug === bannerSlug) {
            score = 1;
          }
        }

        if (!score) return null;
        return { item, score, pathLength: bannerPath.length };
      })
      .filter(Boolean)
      .sort((a, b) => b.score - a.score || b.pathLength - a.pathLength);

    return scoredMatches[0]?.item || null;
  };

  useEffect(() => {
    const fetchPageBanner = async () => {
      const rows = await GetAllPageBannerforWeb();
      const activePath = normalizePath(pathname);
      const matchedBanner = getBestBannerMatch(rows, activePath);

      setMetaTitle(
        matchedBanner?.MetaTitle || `${getPageNameFromPath(activePath)} | AskMeRealty - Real Estate Services`
      );
      setMetaDescription(
        matchedBanner?.MetaDescription ||
        "AskMeRealty - Welcome to our homepage! Explore our real estate services, including property buying, selling, renting, and management. Discover your dream home with us today."
      );
      setMetaKeywords(
        matchedBanner?.MetaKeyword ||
        "Homepage, AskMeRealty, Real Estate Services, Property Buying, Property Selling, Property Renting, Property Management, Real Estate Solutions"
      );
    };

    fetchPageBanner();
  }, [pathname]);

  const fetchProperties = async () => {
    try {
      debugger
      const allProperties = JSON.parse(localStorage.getItem('AllPropertiesforWeb')) || [];
      const featuredProperties = JSON.parse(localStorage.getItem('AllFeaturedPropertiesforWeb')) || [];
      const allPropertyTypes = JSON.parse(localStorage.getItem('AllPropertyTypesforWeb')) || [];
      const timeStamp = JSON.parse(localStorage.getItem('TimeStampforData')) || 0;

      if (allProperties.length === 0 || featuredProperties.length === 0 || allPropertyTypes.length === 0 || new Date().getTime() > timeStamp) {
        await GetAllPropertyforWeb(enqueueSnackbar);
        await GetAllPropertyTypesforWeb(enqueueSnackbar);
      }

      setAllProperties(allProperties);
      setFeaturedProperties(featuredProperties);
      setPropertyTypes(allPropertyTypes);
    } catch (error) {
      console.error("Error fetching properties:", error);
      enqueueSnackbar("Failed to fetch properties. Please try again later.", { variant: "error" });
    }
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  return (
    <>
      <MetaComponent meta={metadata} />
      <Header1 />
      <Hero setLocationName={setLocationName} LocationName={LocationName} />

      <Categories2 LocationName={LocationName} />
      <Properties objFeaturedProperties={objFeaturedProperties} propertyTypes={propertyTypes} />
      <Benefit />
      {/* <Locations /> */}
      <Properties2 />
      {/* <Agents />
      <Testimonials /> */}
      <Blogs2 itemsPerPage={6} onHomePage={true} />
      <Faqs onHomePage={true} />
      {/* <Brands /> */}
      <Footer1 />
    </>
  );
}
